module.exports = __webpack_public_path__ + "img/国肽.9db6c46f.jpg";